import { render } from "./AboutTrusted.vue?vue&type=template&id=4f87d54a&scoped=true"
import script from "./AboutTrusted.vue?vue&type=script&lang=js"
export * from "./AboutTrusted.vue?vue&type=script&lang=js"

import "./AboutTrusted.vue?vue&type=style&index=0&id=4f87d54a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f87d54a"]])

export default __exports__